import React from 'react';

function Edit({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M16 3L21 8L8 21H3V16L16 3Z" />
      <path d="M12.667 6L18.0003 11.3333" />
    </svg>
  );
}

export default Edit;
